import { type ReactElement, type ReactNode } from 'react';

interface TagPillProps {
  children?: ReactNode;
  color?: string;
  icon?: ReactElement;
  testId?: string;
  textColor?: string;
}

const TagPill = ({ children, color = 'primary', icon, testId, textColor = 'white' }: TagPillProps) => (
  <span
    data-testid={testId}
    style={{ height: 24 }}
    className={`bg-${color} d-flex align-items-center mw-full overflow-hidden px-2 rounded-pill text-0_75 fw-bold text-nowrap text-${textColor}`}
  >
    {icon && <span className="d-flex align-items-center flex-shrink-0 me-1">{icon}</span>}
    <span>{children}</span>
  </span>
);

export default TagPill;
